import {
    Event,
    EventMatchedOffer,
    EventMatchedOfferType,
    MatchedOfferAttributeRelevance,
    OfferAttributeName
} from '../../../../common/models/event.interface';
import { EventState } from '../store/event.state';
import { convertUTCDateToTimezone } from '../../../../common/utilities/dates';

export interface MatchedOfferAttributeViewModel {
    value: string | number;
    relevance: MatchedOfferAttributeRelevance;
}

export class EventOfferViewModel {
    public isLinked: boolean;

    public attribute: {
        [K in OfferAttributeName]?: MatchedOfferAttributeViewModel;
    };

    startDateLocal: Date;
    endDateLocal: Date;

    constructor(
        public readonly entity: EventMatchedOffer,
        public readonly event: Event,
        pidMap: EventState['data']['pids']
    ) {
        this.isLinked = this.entity.selected;
        this.attribute = {};

        for (let attr in this.entity.attribute) {
            this.attribute[attr] = {
                value:
                    this.entity.attribute[attr].matchtime_offer_value ||
                    this.entity.attribute[attr].current_offer_value,
                relevance: this.entity.attribute[attr].relevance
            };

            if (attr == 'start_date') {
                this.startDateLocal = convertUTCDateToTimezone(
                    this.attribute[attr].value as string,
                    this.entity.attribute[attr].timezone ||
                        this.event.time_zone ||
                        'UTC'
                );
            }

            if (attr == 'end_date') {
                this.endDateLocal = convertUTCDateToTimezone(
                    this.attribute[attr].value as string,
                    this.entity.attribute[attr].timezone ||
                        this.event.time_zone ||
                        'UTC'
                );
            }
        }

        if (this.attribute.pids && this.attribute.pids.value) {
            // Add spaces between pid commas to simplify text wrapping
            this.attribute.pids.value = String(this.attribute.pids.value)
                .split(',')
                .map(pid => Number(pid.trim()))
                .map(pidId =>
                    pidMap[pidId] ? `${pidMap[pidId].name} - ${pidId}` : pidId
                )
                .join('\n');
        }
    }

    get isManual(): boolean {
        return this.entity.match_type === EventMatchedOfferType.MANUAL;
    }
}
